<!--
 * Created by JackCui on 2021/12/15
 -->

<script>
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
const variableReplace = window.fe.variableReplace
export default {
  name: 'all-select',
  props: {
    total: {
      default: 0,
      type: Number
    },
    changeAll: {
      default: () => {},
      type: Function
    }
  },
  data () {
    return {
      allCheck: false
    }
  },
  methods: {
    handleChange (value) {
      // this.checkAll(value)
      this.changeAll(value)
      this.$emit('change-all', value)
    },
    initAllCheck (val) {
      this.allCheck = val
    }
  },
  render (h) {
    return (
      <div class="all-selcet">
        <el-checkbox v-model={this.allCheck} on-change={this.handleChange} class="select-all">
          {pageText.selectedAll}
        </el-checkbox>
        <span class="fs12" domPropsInnerHTML={variableReplace(pageText.theTotalNumberOfArticle, { n: `<span class="font-color">${this.total}</span>` })}>
        </span>
        {this.allCheck && <span class="fs12" domPropsInnerHTML={variableReplace(pageText.hasBeenSelected, { n: `<span class="font-color">${this.total}</span>` })}>
        </span>}
      </div >
    )
  }
}
</script>

<style scoped lang="scss">
.all-selcet {
  background: #f1f6ff;
  margin-bottom: 5px;
  padding-left: 15px;
  border-radius: 4px;
  border: 1px solid #d6dfff;
  color: #333;
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    color: #333 !important;
  }
  ::v-deep.font-color {
   color: #F5222D;
  }
}
.fs12 {
  font-size: 12px;
  margin-left: 4px;
}
</style>
